// extracted by mini-css-extract-plugin
module.exports = {"text":"PolicyPlainContent_text__FByTu","bold":"PolicyPlainContent_bold__HKV_I","normal":"PolicyPlainContent_normal__2hJ63"};